<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="modalTitle" :modal-id="idModal" @close="back">
            <template v-slot:modal-body>
                <div class="p-x-4 f-regular f-c-black f-16">
                    <p v-if="isSaldo">
                        Tidak dapat menghapus mesin EDC, karena <span class="f-semi">masih ada sisa saldo</span>.
                        Lakukan settlement terlebih dahulu untuk menghabiskan saldo yang aktif, dan pastikan saldo
                        tersisa <span class="f-semi">{{ detailMesin.saldo | currency }}</span
                        >.
                    </p>
                    <p v-else>
                        Tidak dapat menghapus mesin EDC, karena terdapat
                        <span class="f-semi">permintaan settlement yang belum dikonfirmasi</span>. Lakukan konfirmasi
                        terlebih dahulu, dan pastikan saldo tersisa
                        <span class="f-semi">{{ detailMesin.saldo | currency }}</span
                        >.
                    </p>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";

import { moduleName } from "../store/state";

export default {
    name: "ModalDeleteInvalid",
    components: {
        SOSlotModal,
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    data() {
        return {
            idModal: `modal-delete-invalid`,
        };
    },
    mounted() {
        $(`#${this.idModal}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            detailMesin: "detailMesin",
        }),
        isSaldo() {
            return this.$route.params.is_saldo;
        },
        modalTitle() {
            return "Tidak dapat menghapus";
        },
    },
    methods: {
        back() {
            this.$router.push({ name: "mesin.edc.detail" });
        },
        closeModal() {
            $(`#${this.idModal}`).modal("hide");
        },
    },
};
</script>
